import { alpha, Components, Theme } from '@mui/material';

export const getMuiCssBaseline = (
  theme: Theme,
): Components['MuiCssBaseline'] => ({
  styleOverrides: {
    'html, body, #root': {
      minHeight: '100vh',
    },
    html: {
      overflowX: 'hidden',
      scrollBehavior: 'smooth',
    },
    body: {
      position: 'relative',
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      boxSizing: 'border-box',
      fontSize: 16,
      fontWeight: 500,
      lineHeight: 1.2,
      margin: 0,
      padding: 0,
      textRendering: 'optimizeLegibility',
      background: `linear-gradient(236.45deg, ${theme.palette.primary.contrastText} 70.48%, #16152A 92.99%)`,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.text.primary,
      fontFeatureSettings: "'cv11' on, 'case' on, 'calt' off",
      fontFamily: "'Inter', sans-serif",
    },
    a: {
      fontSize: 'inherit',
      textDecoration: 'none',
      transition: `color ${theme.transitions.duration.short}ms`,
      color: theme.palette.primary.main,
    },
    hr: {
      width: '100%',
      borderWidth: '1px 0 0',
      borderStyle: 'solid',
      borderColor: theme.palette.divider,
    },
    'button, input, optgroup, select, textarea': {
      fontFamily: 'inherit',
      fontSize: '100%',
      lineHeight: 1.1,
      margin: 0,
    },
    ul: {
      paddingLeft: theme.spacing(4),
    },
    '::-moz-focus-inner': { borderStyle: 'none', padding: 0 },

    'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    'input[type=number]': {
      MozAppearance: 'textfield',
    },

    'strong, b': {
      fontWeight: 700,
    },
    label: {
      cursor: 'pointer',
    },
    '::-webkit-scrollbar': {
      width: 10,
      height: 10,
    },
    '::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
    '::-webkit-scrollbar-track': {
      background: 'transparent',
      margin: 1,
      borderRadius: 10,
      '&:hover': {
        background: alpha(theme.palette.grey[500], 0.5),
      },
    },
    '::-webkit-scrollbar-thumb': {
      background: alpha(theme.palette.grey[700], 0.5),
      borderRadius: 10,
      transition: `background-color ${theme.transitions.duration.short}ms`,
      '&:hover': {
        background: alpha(theme.palette.grey[700], 0.7),
      },
    },
  },
});
